import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { RadiantSpinner } from 'components/RadiantSpinner'

import { PinnedNote } from 'modules/unsubscribe/components/PinnedNote'
import { useCanceledPlan } from 'modules/unsubscribe/pages/CanceledPlan/useCanceledPlan'

import { FemiButton } from '../../components/FemiButton'
import { FemiPageContainer } from '../../components/FemiPageContainer'
import { FemiBottomArea, FemiContent, FemiOutcomeTitle } from '../../styles'

export const FemiCanceledPlan: React.FC = () => {
  const { t } = useTranslation()
  const { isInProgress, goToAccountPage } = useCanceledPlan()

  return (
    <FemiPageContainer>
      {isInProgress ? (
        <FemiContent>
          <FemiOutcomeTitle>
            {t('retention.canceledPlan.step1Title')}
          </FemiOutcomeTitle>
          <RadiantSpinner />
        </FemiContent>
      ) : (
        <>
          <FemiContent>
            <FemiOutcomeTitle>
              {t('retention.canceledPlan.step2Title')}
            </FemiOutcomeTitle>
            <PinnedNote>
              <Trans
                i18nKey="retention.femi.canceledPlan.note"
                components={{ br: <br /> }}
              />
            </PinnedNote>
          </FemiContent>
          <FemiBottomArea isFixed>
            <FemiButton type="button" onClick={goToAccountPage}>
              {t('retention.femi.canceledPlan.okButton')}
            </FemiButton>
          </FemiBottomArea>
        </>
      )}
    </FemiPageContainer>
  )
}
